(() => {
  const initializeProductPage = (page) => {
    if (page.dataset.oaProductReady === 'true') return;

    const mainImage = page.querySelector('[data-oa-main-image]');
    const thumbnails = [...page.querySelectorAll('[data-oa-thumbnail]')];

    const selectThumbnail = (thumbnail) => {
      if (!thumbnail || !mainImage) return;

      mainImage.src = thumbnail.dataset.imageSrc;
      mainImage.srcset = thumbnail.dataset.imageSrcset || '';
      mainImage.alt = thumbnail.dataset.imageAlt || '';

      thumbnails.forEach((item) => {
        const isActive = item === thumbnail;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-pressed', String(isActive));
      });
    };

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => selectThumbnail(thumbnail));
    });

    const quantityInput = page.querySelector('[data-oa-quantity-input]');
    const quantityMinus = page.querySelector('[data-oa-quantity-minus]');
    const quantityPlus = page.querySelector('[data-oa-quantity-plus]');

    const updateQuantity = (change) => {
      if (!quantityInput) return;
      const minimum = Number.parseInt(quantityInput.min, 10) || 1;
      const current = Number.parseInt(quantityInput.value, 10) || minimum;
      quantityInput.value = Math.max(minimum, current + change);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    quantityMinus?.addEventListener('click', () => updateQuantity(-1));
    quantityPlus?.addEventListener('click', () => updateQuantity(1));

    const variantData = page.querySelector('[data-oa-variants]');
    const optionGroups = [...page.querySelectorAll('[data-oa-option]')];
    const variantIdInput = page.querySelector('[data-oa-variant-id]');
    const price = page.querySelector('[data-oa-product-price]');
    const addToCart = page.querySelector('[data-oa-add-to-cart]');
    let variants = [];

    if (variantData) {
      try {
        variants = JSON.parse(variantData.textContent);
      } catch (error) {
        console.error('Unable to read product variants.', error);
      }
    }

    const updateVariant = () => {
      if (!variants.length || !variantIdInput || !addToCart) return;

      const selectedOptions = optionGroups.map((group) => {
        return group.querySelector('[data-option-value]:checked')?.value;
      });

      const variant = variants.find((item) => {
        return item.options.every((option, index) => option === selectedOptions[index]);
      });

      const buttonText = addToCart.querySelector('span');

      if (!variant) {
        addToCart.disabled = true;
        addToCart.setAttribute('aria-disabled', 'true');
        if (buttonText) buttonText.textContent = 'UNAVAILABLE';
        return;
      }

      variantIdInput.value = variant.id;
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
      if (price) price.textContent = variant.price;

      addToCart.disabled = !variant.available;
      addToCart.toggleAttribute('aria-disabled', !variant.available);
      if (buttonText) buttonText.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';

      if (variant.featuredMediaId) {
        const thumbnail = thumbnails.find((item) => Number(item.dataset.mediaId) === variant.featuredMediaId);
        if (thumbnail) selectThumbnail(thumbnail);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    optionGroups.forEach((group) => {
      group.addEventListener('change', updateVariant);
    });

    page.dataset.oaProductReady = 'true';
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-oa-product-page]').forEach(initializeProductPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
